import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface EntityEnding {
    id: number;
    name: string;
    business_type?: number;
    business_type_name?: string;
    country_type?: string;
    country?: number;
    package?: number;
    status?: number;
}

export const entityEndingApi = createApi({
    reducerPath: "entityEndingApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getEntityEndings: builder.query<EntityEnding[], void>({
            query: () => "/entity-ending/",
        }),
    }),
});

export const { useGetEntityEndingsQuery } = entityEndingApi;

